import { render, staticRenderFns } from "./ThankYouStepper.vue?vue&type=template&id=21b0d031&scoped=true"
import script from "./ThankYouStepper.vue?vue&type=script&lang=js"
export * from "./ThankYouStepper.vue?vue&type=script&lang=js"
import style0 from "./ThankYouStepper.vue?vue&type=style&index=0&id=21b0d031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b0d031",
  null
  
)

export default component.exports